import { render, staticRenderFns } from "./Lsbdbj.vue?vue&type=template&id=3b84b518&scoped=true"
import script from "./Lsbdbj.vue?vue&type=script&lang=js"
export * from "./Lsbdbj.vue?vue&type=script&lang=js"
import style0 from "./Lsbdbj.vue?vue&type=style&index=0&id=3b84b518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84b518",
  null
  
)

export default component.exports